import "core-js/features/promise";
import "core-js/features/object";
import "core-js/features/array";
import { createStore } from "vuex";
import event from "./modules/event";
import calendar from "./modules/calendar";
import calendarFilter from "./modules/calendarFilter";
import regForm from "./modules/regForm";
import api from "../apis/api";

const store =
  window.store ||
  createStore({
    modules: {
      event,
      // calendar,
      calendarFilter,
      regForm,
    },
    state: {
      contentFilterBlockData: [],
    },
    getters: {
      getContentFilterBlockData: (state) => state.contentFilterBlockData,
    },
    mutations: {
      SET_FILTERED_CONTENT(state, data) {
        state.contentFilterBlockData = data;
      },
    },
    actions: {
      fetchFilteredContent({ commit }, vid) {
        return new Promise((resolve, reject) => {
          api.getFilteredContent(vid).then((response) => {
            commit("SET_FILTERED_CONTENT", response.data);
            resolve();
          });
        });
      },
    },
  });
if (window.store === undefined) {
  window.store = store;
}

export default store;
